import { algoliasearch } from "algoliasearch";

const appId = process.env.REACT_APP_ALGOLIA_APP_ID || "ZV9CMEOHVR";
const searchKey =
  process.env.REACT_APP_ALGOLIA_SEARCH_KEY ||
  "6fe7688757de7afc15332cb6b0b5c911";

export const ALGOLIA_INDEX =
  process.env.REACT_APP_ALGOLIA_INDEX || "production";

const searchClient = algoliasearch(appId, searchKey);

export default searchClient;
